export const getRoles = (member) => {
    if (!member) return [];
    const { isAdmin, isBountyManager, isBountyValidator, isTreasurer } = member;
    const obj = { isAdmin, isBountyManager, isBountyValidator, isTreasurer };
    const roles = Object.keys(obj).filter((role) => obj[role]);

    return roles;
};
